import {useTranslation} from "react-i18next";
import {AVAILABLE_LANGS} from "../../i18n";

const Language = () => {
    const {i18n} = useTranslation('language')
    const currentLanguage = i18n.language.split('-')[0].toUpperCase()

    return (
        <div className="foot-toggle me-2">
            {AVAILABLE_LANGS.map(lang => (
                <button
                    key={lang}
                    className={currentLanguage === lang ? 'on' : 'off'}
                    onClick={() => i18n.changeLanguage(lang.toLowerCase())}
                >
                    {lang}
                </button>
            ))}
        </div>
    )
}


export default Language;
